import { render, staticRenderFns } from "./DesignMenuNavi.vue?vue&type=template&id=6f7a2fa5&scoped=true&"
import script from "./DesignMenuNavi.vue?vue&type=script&lang=ts&"
export * from "./DesignMenuNavi.vue?vue&type=script&lang=ts&"
import style0 from "./DesignMenuNavi.vue?vue&type=style&index=0&id=6f7a2fa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a2fa5",
  null
  
)

export default component.exports